exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-blogs-js": () => import("./../../../src/pages/blogs.js" /* webpackChunkName: "component---src-pages-blogs-js" */),
  "component---src-pages-sv-blogs-js": () => import("./../../../src/pages/sv/blogs.js" /* webpackChunkName: "component---src-pages-sv-blogs-js" */),
  "component---src-templates-blog-js": () => import("./../../../src/templates/blog.js" /* webpackChunkName: "component---src-templates-blog-js" */),
  "component---src-templates-front-page-js": () => import("./../../../src/templates/front-page.js" /* webpackChunkName: "component---src-templates-front-page-js" */)
}

